import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PaymentConfigEffects } from './state/payment-config.effects';
import { reducers } from './state/payment-config.selectors';

@NgModule({
  imports: [

    StoreModule.forFeature('paymentConfig', reducers),
    EffectsModule.forFeature([PaymentConfigEffects]),
  ],
  declarations: []
})
export class PaymentConfigScreenModule { }